(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropstrap-header"]) return;
  try {
    
  document.querySelectorAll('.ds-header__mobile-menu').forEach(menu => {
    const summary = menu.querySelector('summary');
    const close = () => {
      menu.open = false;
      document.body.classList.remove('ds-menu-open');
      summary.setAttribute('aria-label', summary.dataset.openLabel);
    };
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('ds-menu-open', menu.open);
      summary.setAttribute('aria-label', menu.open ? summary.dataset.closeLabel : summary.dataset.openLabel);
    });
    menu.querySelector('.ds-header__menu-close').addEventListener('click', () => { close(); summary.focus(); });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.open) { close(); summary.focus(); } });
    document.addEventListener('click', event => { if (menu.open && !menu.closest('.ds-header').contains(event.target)) close(); });
    window.matchMedia('(min-width: 750px)').addEventListener('change', event => { if (event.matches) close(); });
    window.addEventListener('pageshow', close);
  });

  function protectBuyingArea() {
    const areas = document.querySelectorAll('.ds-product__info, .ds-buy-section__info, .cart__footer');
    if (!areas.length || !('IntersectionObserver' in window)) return;
    const visible = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      document.body.classList.toggle('ds-buy-focus', visible.size > 0);
    });
    areas.forEach((area) => observer.observe(area));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', protectBuyingArea);
  else protectBuyingArea();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropstrap-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ds-buy-section__info').forEach((info) => {
    info.querySelectorAll('.ds-pack-options input').forEach((radio) => {
      radio.addEventListener('change', () => {
        const price = info.querySelector('.ds-price');
        if (price) price.textContent = radio.dataset.price;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropstrap-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ds-product-section').forEach((section) => {
    const artwork = section.querySelector('input[type="file"]');
    if (artwork) artwork.addEventListener('change', () => {
      const file = artwork.files[0];
      artwork.setCustomValidity(file && !file.name.toLowerCase().endsWith('.pdf') ? artwork.dataset.pdfError : '');
    });
    const radios = section.querySelectorAll('.ds-pack-options input');
    if (!radios.length) return;
    const price = section.querySelector('.ds-product-price');
    const stickyPrice = section.querySelector('.ds-sticky-price');
    radios.forEach((radio) => radio.addEventListener('change', () => {
      const formattedPrice = radio.dataset.price;
      if (price) price.textContent = formattedPrice;
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      section.querySelectorAll('[data-two-unit]').forEach((image) => {
        image.hidden = radio.value !== image.dataset.twoUnit;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
